import { Stack, Typography } from '@mui/material';
import { Spacings5 } from '@efexteam/design-tokens';
import { useTranslation } from 'react-i18next';
import EmailValidation from '../emailValidation';

const AddMemberStep = ({
  canContinue,
}: {
  canContinue: (value: boolean) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Stack sx={{ gap: Spacings5 }}>
      <Typography variant="h4">{t('crtMmbStep1')}</Typography>
      <EmailValidation canContinue={canContinue} />
    </Stack>
  );
};

export default AddMemberStep;
